import script from "./RecordLeaders.vue?vue&type=script&setup=true&lang=ts"
export * from "./RecordLeaders.vue?vue&type=script&setup=true&lang=ts"

import "./RecordLeaders.vue?vue&type=style&index=0&id=1ff2be30&scoped=true&lang=css"

import exportComponent from "E:\\Sites\\mk64\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ff2be30"]])

export default __exports__